import { render, staticRenderFns } from "./vehicle_capacity.vue?vue&type=template&id=cf52edae"
import script from "./vehicle_capacity.vue?vue&type=script&lang=js"
export * from "./vehicle_capacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports